// Vendor imports
const classNames = require('classnames')
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AppFooter')

const SOCIAL_ACCOUNTS = [
  {
    provider: 'instagram',
    href: 'https://instagram.com/getmixapp',
    title: 'Check us out on Instagram'
  },
  {
    provider: 'facebook',
    href: 'https://facebook.com/getmix',
    title: 'Friend us on Facebook'
  },
  {
    provider: 'twitter',
    href: 'https://twitter.com/getmixapp',
    title: 'Follow us on Twitter'
  }
]

// IOS & ANDROID URLS Use Branch.io links to direct the user to respective Stores
const IOS_URL = 'https://link.mix.com/E9H0NE9sdO'
const ANDROID_URL = 'https://link.mix.com/E9H0NE9sdO'
const FIREFOX_URL = 'https://addons.mozilla.org/en-US/firefox/addon/mix-com/'
const CHROME_URL = 'https://chrome.google.com/webstore/detail/jdgmgdpcphmdofoplgjifmdajnfojnin'
const SAFARI_URL = 'https://itunes.apple.com/us/app/mix/id1451360134?mt=12'

class AppFooter extends React.PureComponent {

  renderBadge(label, href, modifier) {
    return (
      tag('a', {
        href,
        className: bem.element('badge-href', modifier)
      },
        tag('span', {
          className: bem.element('badge-image', modifier)
        }),
        tag('span', {
          className: bem.element('badge-label', modifier)
        },
          label
        )
      )
    )
  }

  renderBrandingColumn() {
    return (
      tag('div', {
        className: bem.element('column', 'branding')
      },
        tag('div', {
          className: bem.element('logo-text')
        })
      )
    )
  }

  renderCompanyColumn() {
    return (
      tag('div', {
        className: bem.element('column', 'company')
      },
        this.renderHeading('Company', 'company'),
        this.renderContactHref(),
        this.renderHref('Careers', '/careers'),
        this.renderHref('Press', 'mailto:press@mix.com'),
        this.renderHref('Terms', '/tos'),
        this.renderHref('Privacy', '/privacy'),
        this.renderHref('Guidelines', 'https://support.mix.com/community-rules/mix-community-guidelines'),
        this.renderHref('Community', 'https://community.mix.com')
      )
    )
  }

  renderContactHref() {
    return (
      tag('a', {
        className: bem.element('href'),
        href: 'mailto:support@mix.com',
        onClick: this.props.onContactClick
      },
        'Contact Us'
      )
    )
  }

  renderCopyright() {
    const currentYear = (new Date()).getUTCFullYear()
    return (
      tag('div', {
        className: bem.element('copyright')
      },
        `© ${currentYear} Mix is an `,
        tag('a', {
          className: bem.element('copyright-href'),
          href: 'https://expa.com/'
        },
          'Expa'
        ),
        ' company'
      )
    )
  }

  renderDownloadColumn() {
    return (
      tag('div', {
        className: bem.element('column', 'download')
      },
        this.renderHeading('Download', 'download'),
        tag('div', {
          className: bem.element('download-container')
        },
          tag('div', {
            className: bem.element('badges', 'apps')
          },
            this.renderBadge('Download our iOS app', IOS_URL, 'ios'),
            this.renderBadge('Download our Android app', ANDROID_URL, 'android')
          ),
          tag('div', {
            className: bem.element('badges', 'extensions')
          },
            this.renderBadge('Install our Firefox Add-on', FIREFOX_URL, 'firefox'),
            this.renderBadge('Install our Chrome extension', CHROME_URL, 'chrome'),
            this.renderBadge('Install our Safari extension', SAFARI_URL, 'safari')
          )
        ),
        tag('div', {
            className: bem.element('badges', 'buttons')
          },
          tag('a', {
              className: bem.element('href'),
              href: 'https://community.mix.com/blog/2018/7/12/add-a-mix-badge-gsask'
            },
            'Add a Mix Button to Your Site'
          )
        )
      )
    )
  }

  renderFollowColumn() {
    const accountSection = this.props.loggedIn && [
      this.renderHeading('Your Account', 'user'),
      this.renderHref('Settings', '/settings'),
      this.renderHref('Log out', '/logout')
    ]
    return (
      tag('div', {
        className: bem.element('column', 'follow')
      },
        this.renderHeading('Follow Us', 'follow'),
        this.renderHref('Instagram', 'https://instagram.com/getmixapp'),
        this.renderHref('Facebook', 'https://facebook.com/getmix'),
        this.renderHref('Twitter', 'https://twitter.com/getmixapp'),
        ...(accountSection || [])
      )
    )
  }

  renderHeading(label, modifier) {
    return (
      tag('div', {
        className: bem.element('heading', modifier)
      },
        label
      )
    )
  }

  renderHref(label, href) {
    return (
      tag('a', {
        href,
        className: bem.element('href')
      },
        label
      )
    )
  }

  renderSocialAccounts() {
    return (
      tag('div', {
        className: bem.element('social-accounts')
      },
        SOCIAL_ACCOUNTS.map(account =>
          tag('a', {
            key: account.provider,
            className: bem.element('social-account', account.provider),
            href: account.href,
            rel: 'nofollow noopener',
            target: '_blank',
            title: account.title
          })
        )
      )
    )
  }

  render() {
    if (this.props.hidden) {
      return null
    }
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        tag('div', {
          className: bem.element('columns-row')
        },
          this.renderBrandingColumn(),
          this.renderCompanyColumn(),
          this.renderFollowColumn(),
          this.renderDownloadColumn()
        ),
        tag('div', {
          className: bem.element('copyright-row')
        },
          this.renderCopyright(),
          this.renderSocialAccounts()
        )
      )
    )
  }
}

AppFooter.propTypes = {
  // Values
  className: PropTypes.string,
  hidden: PropTypes.bool,
  loggedIn: PropTypes.bool,
  // Callbacks
  onContactClick: PropTypes.func
}

module.exports = AppFooter
